type QuickstartStepKey =
  | 'users_setup'
  | 'jobs_setup'
  | 'phone_number_setup'
  | 'recruiting_social_ads_setup'
  | 'postmark_email_verified'
  | 'scheduled_kickoff_call';

export type QuickstartStep = {
  key: QuickstartStepKey;
  title: string;
  description: string;
  buttonText: string;
  link: string;
  disabled: boolean;
  completed: boolean;
};

export const initialQuickstartSteps: QuickstartStep[] = [
  {
    key: 'phone_number_setup',
    title: 'Setup your Humaniz phone number',
    description: "You'll need a phone number to send and receive text messages to candidates and agents on your team.",
    link: '/quickstart/phone_number',
    buttonText: 'Setup',
    disabled: false,
    completed: false,
  },
  {
    key: 'postmark_email_verified',
    title: 'Verify your email address',
    description:
      'Verify your email with Postmark so you can send emails to candidates and teammates from Humaniz.',
    link: '/settings/account/email',
    buttonText: 'Verify',
    disabled: false,
    completed: false,
  },
  {
    key: 'jobs_setup',
    title: 'Post your first job',
    description: 'Post your first job to Humaniz so you can start interviewing candidates.',
    link: '/jobs?sort=created&order=desc&status=Active&quickstart=true',
    buttonText: 'Post a job',
    disabled: false,
    completed: false,
  },
  {
    key: 'recruiting_social_ads_setup',
    title: 'Setup social ads for recruiting',
    description: 'We use social ads to target experienced agents in your area.',
    link: '/quickstart/meta',
    buttonText: 'Start',
    disabled: false,
    completed: false,
  },
  {
    key: 'users_setup',
    title: 'Invite your teammates (optional)',
    description:
      'Running a high performance team is hard. Invite your supporting teammates to help interview candidates, coach your agents, and facilitate a smooth onboarding process.',
    buttonText: 'Invite',
    link: '/settings/company/users?quickstart=true',
    disabled: false,
    completed: false,
  },
  {
    key: 'scheduled_kickoff_call',
    title: 'Schedule a kickoff call',
    description:
      'Have all of the above done? Schedule a kickoff call with our team so you can get the most out of Humaniz!',
    link: '/quickstart/schedule_kickoff_call',
    buttonText: 'Schedule',
    disabled: true,
    completed: false,
  },
];
